import { IFixStep, IFixStepAction } from "./fixStepReducer";

export function updateFixSteps(steps: IFixStep[]): IFixStepAction {
    return {
        type: 'FIX_STEP_UPDATE',
        payload: steps,
    }
}